<script setup lang="ts">
import { WidgetQuiz } from '~/components/widget/quiz'
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetTrendingNews } from '~/components/widget/trending-news'
import { WidgetCustomerCare } from '~/components/widget/customer-care'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import type { IQuiz } from '~/components/widget/quiz'
import { useSeoFromCustom } from '~/composables/useSeoFromCustom'

const { locale, t } = useI18n()
const route = useRoute()
const quizId = Number(route.params.id)

const { data } = await useApi<{ data: IQuiz }>(`/quizzes/${quizId}`)
const quiz = computed(() => data.value?.data ?? null)

if (!quiz.value) showError({ statusCode: 404 })

useSeoFromCustom(
  computed(() => quiz.value ?? undefined),
  undefined,
  locale.value
)

const breadcrumbs = computed(() => [
  { title: t('page.quiz.breadcrumb'), url: '/quiz' },
  { title: quiz.value?.title ?? '', url: route.path }
])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside>
            <WidgetTrendingNews />
            <WidgetCustomerCare />
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
          </aside>
        </template>
        <div class="space-y-5">
          <!-- The backend crops the main image to 1085x651 like the news cover;
               the ratio keeps the space reserved before the image loads -->
          <img
            v-if="quiz?.main_image_url"
            class="aspect-[1085/651] h-auto w-full rounded-lg object-cover"
            fetchpriority="high"
            :src="quiz.main_image_url"
            :alt="quiz.title"
            width="1085"
            height="651"
          />
          <WidgetQuiz v-if="quiz" :quiz="quiz" />
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
